import React, {Component} from 'react';
import { loginsso,getCurrentUser,getFetchUrlParams} from '../../util/APIUtils';
import { ACCESS_TOKEN ,SESSION_USER,SSO_PARAMS} from '../../constants';
import base64 from 'hacktiv8-base64';

export default class LoginAuto extends Component {

	constructor(props) {
		super(props);
		localStorage.removeItem(ACCESS_TOKEN);
		localStorage.removeItem(SESSION_USER);
		//this.getFetchUrlParams = this.getFetchUrlParams.bind(this);
	}
	componentDidMount() {

		console.log(this.props.location.search);
		var params = getFetchUrlParams(this.props.location.search);
	
		var loginuserid=base64.decode(this.props.match.params.ssoid);
		//alert(loginuserid);
		//var loginuserid=this.props.match.params.ssoid;
		//console.log(params);
	     params['ssoid']=loginuserid;
		//console.log(params);

		if(params.ssoid){
            var fields={"usernameOrEmail":loginuserid,"password":"ssopassword"};
           
			loginsso(fields)
			.then(response => {
				//console.log(response);
				localStorage.setItem(ACCESS_TOKEN, response.accessToken);
                localStorage.setItem(SSO_PARAMS,JSON.stringify(params));

                 getCurrentUser()
              .then(response => {
                 //console.log(response);
                this.setState({
                  currentUser: response,
                  isAuthenticated: true
                });

                localStorage.setItem(SESSION_USER, JSON.stringify(response));
                this.props.history.push("/schedule");
              }).catch(error => {
                  alert("app js loadCurrentUser");
              });




			}).catch(error => {
				alert('Access Denied')
			}); 
		}




	}




	render(){
		return (


			<div className="row">
		
			</div>


			);
		} 
	}